import { useEffect, useState } from 'react';

const showAlertEventName = 'ConcurrentAuthAlert';

export const showAlert = () => {
  document.dispatchEvent(new Event(showAlertEventName));
};

export const useStore = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleShowAlert = () => {
      setShow(true);
    };

    document.addEventListener(showAlertEventName, handleShowAlert);

    return () => {
      document.removeEventListener(showAlertEventName, handleShowAlert);
    };
  }, []);

  return {
    show,
  };
};
